import "./wallet.scss";
// import ManagementSidebar from "components/common/ManagementSidebar";
import Statistics from "../statistics/Statistics";
import WalletCard from "./WalletCard";
import { useState, useEffect } from "react";
// import { connection } from "utils/apiConnection.ts";
// import UnblockWallet from "components/FinancialSuperAdmin/UnblockWalletCardModal";
import l1 from "../../../assets/images/superadmin/l1 (4).svg";
import l3 from "../../../assets/images/superadmin/l1 (2).svg";
import l2 from "../../../assets/images/superadmin/l1 (3).svg";
import l4 from "../../../assets/images/superadmin/l1 (1).svg";
import useAxios from "../../../services/useAxios";
import toast from "react-hot-toast";

export default function WalletList() {
  const [isLoading, setIsLoading] = useState(false);
  const [updater, setUpdater] = useState(false);
  const [selectedItem, setSelectedItem] = useState(1);
  const [WalletCardData, setWalletCardData] = useState([]);
  useEffect(() => {
    getWalletsFun();
    // connection("superadminapi/get_wallets").then((data) => {
    //   setWalletCardData(data.data.wallets);
    // });
  }, [updater]);
  const { execute: getWallets } = useAxios("superadminapi/get_wallets");
  async function getWalletsFun() {
    setIsLoading(true);
    await getWallets().then((res) => {
      setWalletCardData(res.data.wallets);
      console.log("datainn:", res.data);
      setIsLoading(false);
    });
  }
  console.log("wallet", WalletCardData);

  // مسدود کردن ولت api
  const { execute: stopHandler } = useAxios("api/Update_Wallets");
  async function stopHandlerFun(id, uid) {
    setIsLoading(true);
    await stopHandler({
      keyvalues: `main_status,1`,
      conditions: `id/=/${id}@@uid/=/${uid}@@main_status/=/${0}`,
    }).then((res) => {
      if (res.status == 1) {
        toast.success("  ولت با موفقیت متوقف شد");
        setIsLoading(false);
        setUpdater(!updater);
      } else {
        toast.error("  خطا در متوقف کردن  ولت!");
        setIsLoading(false);
      }
      console.log("datainn:", res.data);
    });
  }
  // const stopHandler = (id, uid) => {
  //   setIsLoading(true);
  //   let myFormData = new FormData();
  //   myFormData.append("keyvalues", `main_status,1`);
  //   myFormData.append(
  //     "conditions",
  //     `id/=/${id}@@uid/=/${uid}@@main_status/=/${0}`
  //   );
  //   axios
  //     .post(`https://sabadi.ir/api/api/Update_Wallets`, myFormData)
  //     .then((res) => {
  //       if (res.data.status == 1) {
  //         toast.success("  ولت با موفقیت متوقف شد");
  //         setIsLoading(false);
  //         setUpdater(!updater);
  //       } else {
  //         toast.error("  خطا در متوقف کردن  ولت!");
  //         setIsLoading(false);
  //       }
  //     });
  // };

  // api فعال کردن ولت
  const { execute: unblockHandler } = useAxios("api/Update_Wallets");
  async function unblockHandlerFun(id, uid) {
    setIsLoading(true);
    await unblockHandler({
      keyvalues: `main_status,0`,
      conditions: `id/=/${id}@@uid/=/${uid}@@main_status/=/${1}`,
    }).then((res) => {
      if (res.status == 1) {
        toast.success("  ولت با موفقیت فعال شد");
        setIsLoading(false);
        setUpdater(!updater);
      } else {
        toast.error("  خطا در فعال کردن  ولت!");
        setIsLoading(false);
      }
      console.log("datainn:", res.data);
    });
  }
  // const unblockHandler = (id, uid) => {
  //   setIsLoading(true);
  //   let myFormData = new FormData();
  //   myFormData.append("keyvalues", `main_status,0`);
  //   myFormData.append(
  //     "conditions",
  //     `id/=/${id}@@uid/=/${uid}@@main_status/=/${1}`
  //   );
  //   axios
  //     .post(`https://sabadi.ir/api/api/Update_Wallets`, myFormData)
  //     .then((res) => {
  //       if (res.data.status == 1) {
  //         toast.success("  ولت با موفقیت فعال شد");
  //         setIsLoading(false);
  //         setUpdater(!updater);
  //       } else {
  //         toast.error("  خطا در فعال کردن ولت!");
  //         setIsLoading(false);
  //       }
  //     });
  // };
  return (
    <>
      <div className=" w-100 mt-2 d-flex  " id="wallet-list">
        {/* <ManagementSidebar /> */}
        <div className="container">
          {/* report Cards */}
          <div className="d-flex flex-wrap">
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد کل تامین کنندگان"
                type={1}
                txt="تامین کننده"
                number={145}
                icon={l1}
              />
            </div>
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد تامین کنندگان فعال"
                type={2}
                txt="تامین کنند فعال"
                number={145}
                icon={l2}
              />
            </div>
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد سوپر مارکت ها"
                type={3}
                txt="سوپرمارکت"
                number={145}
                icon={l3}
              />
            </div>
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد پروتئینی ها"
                type={4}
                txt="پروتئینی"
                number={145}
                icon={l4}
              />
            </div>
          </div>
          <WalletCard
            WalletCardData={WalletCardData}
            stopHandler={stopHandlerFun}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            unblockHandler={unblockHandlerFun}
          />
        </div>
      </div>
    </>
  );
}
